module.exports = __webpack_public_path__ + "img/icon-file.bb223ccb.svg";